<template>
  <div class="text-h5 text-md-h4 font-weight-bold" :class="[`${color}--text`]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
    },
  },
};
</script>
